import { render, staticRenderFns } from "./policyInfo.vue?vue&type=template&id=5f8674ae&scoped=true"
import script from "./policyInfo.vue?vue&type=script&lang=js"
export * from "./policyInfo.vue?vue&type=script&lang=js"
import style0 from "./policyInfo.vue?vue&type=style&index=0&id=5f8674ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8674ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f8674ae')) {
      api.createRecord('5f8674ae', component.options)
    } else {
      api.reload('5f8674ae', component.options)
    }
    module.hot.accept("./policyInfo.vue?vue&type=template&id=5f8674ae&scoped=true", function () {
      api.rerender('5f8674ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/customerManage/policyInfo.vue"
export default component.exports